import { AiOutlineScan } from 'react-icons/ai';
import { MdOutlineAddPhotoAlternate } from 'react-icons/md';
import { MdOutlineChevronLeft } from 'react-icons/md';
import { MdOutlineChevronRight } from 'react-icons/md';
import { AiOutlinePlus } from 'react-icons/ai';
import { AiOutlineSetting } from 'react-icons/ai';
import { LuHome } from 'react-icons/lu';
import { LuUserCog } from 'react-icons/lu';
import { IoSunnyOutline } from 'react-icons/io5';
import { MdOutlineIosShare } from 'react-icons/md';

export const ICONS = {
  scan: <AiOutlineScan />,
  addPhoto: <MdOutlineAddPhotoAlternate />,
  chevronLeft: <MdOutlineChevronLeft />,
  chevronRight: <MdOutlineChevronRight />,
  plus: <AiOutlinePlus />,
  settings: <AiOutlineSetting />,
  home: <LuHome />,
  userConfig: <LuUserCog />,
  sun: <IoSunnyOutline />,
  iosShare: <MdOutlineIosShare />,
};
